/** Les signalements, la moderation et l'administration. */
export const moderation = {
  erreurs: {
    compteOfficiel: "Le compte de l'application ne se signale pas. Écris-lui pour toute question.",
  },
  contenu: {
    supprime: '(contenu supprimé)',
    sansTexte: '(sans texte)',
  },
  merci: {
    emailParti: 'Si un compte existe, un e-mail vient de partir.',
    post: 'Merci, notre équipe va regarder ça. Ce post ne s’affichera plus pour toi.',
    signalement: 'Signalement envoyé. Merci, on regarde ça.',
    sortie: 'Merci, notre équipe va regarder ça. Cet événement ne s’affichera plus pour toi.',
    simple: 'Merci, notre équipe va regarder ça.',
    membre: 'Merci, notre équipe va regarder ça. Ce membre est bloqué en attendant.',
    support: 'Message envoyé. Notre équipe te répond par e-mail.',
  },
  raisons: {
    spam: 'Spam',
    harassment: 'Harcèlement',
    shocking: 'Contenu choquant',
    misinformation: 'Fausse information',
    other: 'Autre',
  },
  admin: {
    durees: {
      jour: '24 heures',
      semaine: '7 jours',
      mois: '30 jours',
      sansTerme: 'Sans terme',
    },
    echec: "Ça n'a pas pu se faire.",
    fait: (geste: string) => `${geste} : c’est fait.`,
    gestes: {
      avertir: 'Avertir',
      liberer: 'Rendre la parole',
      museler: 'Réduire au silence',
      retablir: 'Rétablir le compte',
      suspendre: 'Suspendre le compte',
      suspendreQ: 'Suspendre ce compte ?',
      retirerCoche: 'Retirer la coche',
      poserCoche: 'Poser la coche',
      nommerModerateur: 'Nommer modérateur',
      nommerAdmin: 'Nommer administrateur',
      retirerRole: 'Retirer le rôle',
      supprimer: 'Supprimer le compte',
      supprimerQ: 'Effacer ce compte et tout ce qu’il a écrit ? Rien ne le rendra.',
    },
    titre: 'Administration',
    chercherMembre: 'Chercher un membre',
    sonPseudo: 'Son pseudo',
    chercher: 'Chercher',
    personne: 'Personne à ce pseudo',
    autre: '← Chercher quelqu’un d’autre',
    rien: 'Rien à signaler',
    avertissements: 'Avertissements',
    texteMembre: 'Ce que le membre lira',
    pourquoi: 'Pourquoi (gardé au journal)',
    etat: {
    administrateur: 'administrateur',
    moderateur: 'modérateur',
    verifie: 'vérifié',
    suspendu: 'suspendu',
    muetJusqua: (date: string) => `sans parole jusqu’au ${date}`,
    muet: 'sans parole, sans terme',
    signalements: (n: number) => `${n} signalements`,
    avertissements: (n: number) => `${n} avertissements`,
    lu: 'lu',
    pasLu: 'pas encore lu',
  },
  },
  avertissement: {
    titre: 'Avertissement',
    compris: 'J’ai compris',
  },
  file: {
    onglets: {
      ouverts: 'À traiter',
      traites: 'Traités',
      tout: 'Tout',
    },
    natures: {
      post: 'Post',
      comment: 'Commentaire',
      event: 'Événement',
      user: 'Membre',
      conversation: 'Conversation',
      help: 'Message d’aide',
    },
    masque: 'Contenu masqué.',
    suspendu: 'Membre suspendu.',
    classe: 'Signalement classé.',
    titre: 'Modération',
    masquer: 'Masquer le contenu',
    suspendre: 'Suspendre le membre',
    classer: 'Classer sans suite',
    rienATraiter: 'Rien à traiter',
    rienIci: 'Rien ici',
    aucunEnAttente: 'Aucun signalement en attente. C’est bon signe.',
    traitesIci: 'Les signalements traités apparaîtront ici.',
    etatMasque: 'Contenu masqué',
    etatSuspendu: 'Membre suspendu',
    etatClasse: 'Classé sans suite',
    traiter: 'Traiter',
    suspendreQ: (nom: string) => `Suspendre ${nom} ? Son accès est coupé jusqu’à rétablissement.`,
    signalements: (n: number) => `${n} signalements`,
    signalePar: (nom: string) => `signalé par ${nom}`,
  },
  signaler: {
    quoi: {
      post: 'ce post',
      comment: 'cette réponse',
      event: 'cet événement',
      member: 'ce membre',
      conversation: 'cette conversation',
    },
    impossible: 'Envoi impossible pour le moment.',
    titre: 'Signaler',
    indisponible: "Ce contenu n'est plus disponible.",
    envoyer: 'Envoyer',
    motif: 'Pour quel motif ?',
    detail: 'Détaille si tu veux',
    detailExemple: "Facultatif : ce qui s'est passé, et depuis quand.",
    intro: (quoi: string) =>
    `Dis-nous ce qui ne va pas avec ${quoi}. Notre équipe regarde chaque signalement, et la personne concernée n'est pas prévenue.`,
  },
};
